import React from 'react';
import { Container, Box } from '@mui/material';
import StockReceivedReportTable from '../../components/report/StockReceivedReportTable';

const StockReceivedReportPage = () => {
  return (
    <Container maxWidth="xl">
      <Box sx={{ py: 3 }}>
        <StockReceivedReportTable />
      </Box>
    </Container>
  );
};

export default StockReceivedReportPage; 